export default "__VITE_ASSET__34X6P0lf__"